export var getImagesList = function getImagesList(encounter) {
  var imagesList = [];
  if (encounter.document_references) {
    var _encounter$document_r;
    (_encounter$document_r = encounter.document_references) === null || _encounter$document_r === void 0 || _encounter$document_r.map(function (documentReference) {
      return imagesList.push({
        name: documentReference.type_text || "Document Reference",
        url: "",
        contentType: "",
        sourceType: "document_reference",
        sourceData: documentReference
      });
    });
  }
  if (encounter.service_requests && Array.isArray(encounter.service_requests)) {
    encounter.service_requests.forEach(function (serviceRequest) {
      var _serviceRequest$diagn, _serviceRequest$diagn2;
      if ((_serviceRequest$diagn = serviceRequest.diagnostic_report) !== null && _serviceRequest$diagn !== void 0 && _serviceRequest$diagn.binary && (_serviceRequest$diagn2 = serviceRequest.diagnostic_report) !== null && _serviceRequest$diagn2 !== void 0 && _serviceRequest$diagn2.code_text) {
        imagesList.push({
          name: serviceRequest.diagnostic_report.code_text,
          url: "",
          contentType: "",
          sourceType: "diagnostic_report",
          sourceData: serviceRequest.diagnostic_report
        });
      }
    });
  }
  return imagesList;
};